module.exports = __webpack_public_path__ + "img/9788958072492.39cb19e2.jpg";